import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { AcademyConnectionWorkspaceDetailsFragmentDoc } from '../../fragments/generated/AcademyConnectionWorkspaceDetails';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type AcademyRelatedConnectionQueryVariables = Types.Exact<{
  filters: Types.RelatedConnectionsFilters;
}>;


export type AcademyRelatedConnectionQuery = { relatedConnections: { workspaceDetails: Array<{ workspaceId: string, workspaceName: string, workspaceLogo?: string | null, icon?: string | null, uri: string }> } };


export const AcademyRelatedConnectionDocument = /*#__PURE__*/ gql`
    query academyRelatedConnection($filters: RelatedConnectionsFilters!) {
  relatedConnections(filters: $filters) {
    workspaceDetails {
      ...AcademyConnectionWorkspaceDetails
    }
  }
}
    ${AcademyConnectionWorkspaceDetailsFragmentDoc}`;

export function useAcademyRelatedConnectionQuery(options: Omit<Urql.UseQueryArgs<AcademyRelatedConnectionQueryVariables>, 'query'>) {
  return Urql.useQuery<AcademyRelatedConnectionQuery, AcademyRelatedConnectionQueryVariables>({ query: AcademyRelatedConnectionDocument, ...options });
};